import React, { useContext } from "react";
import { Grid, Typography, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import { Facebook, YouTube, LinkedIn, CloseSharp } from "@mui/icons-material";
import XIcon from '@mui/icons-material/X';
import Draggable from "react-draggable";

const DraggableBox = React.forwardRef(({ children, ...props }, ref) => (
    <Draggable handle=".header">
        <div ref={ref} {...props}>{children}</div>
    </Draggable>
));

const CompanyInfoPage = ({ companyData, isOpen, onClose }) => {
    console.log(companyData);
    const { darkMode } = useContext(ThemeContext);

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm" PaperComponent={(props) => (
            <DraggableBox {...props} style={{ position: "absolute", top: "10%", left: "30%", transform: "translate(-50%, -50%)" }} />)}
            sx={{ "& .MuiDialog-paper": { backgroundColor: darkMode ? "#0f1720" : "var(--white)", color: darkMode ? "#d1d1d1" : "#333", boxShadow: darkMode ? "0px 16px 46px 8px rgba(0, 0, 0, 0.12)" : "0 10px 20px rgba(169, 169, 169, 0.3), 4px 4px 10px rgba(169, 169, 169, 0.2), -4px 4px 5px rgba(169, 169, 169, 0.1)", }, }}>
            <DialogTitle sx={{ padding: '12px', cursor: "move", display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: darkMode ? "#1976d2" : "#1976d2", color: "white", }} className="header">
                <Typography variant="body2">{companyData?.companyName}</Typography>
                <CloseSharp onClick={onClose} sx={{ cursor: "pointer", fontSize: '18px' }} />
            </DialogTitle>
            <DialogContent sx={{ padding: 2, overFlowY: 'scroll'}}>
                <Grid container sx={{ padding: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {companyData?.logoUrl && (
                        <img src={companyData.logoUrl} alt="Company Logo" style={{ width: 90, height: 90, marginBottom: 20 }} />
                    )}
                    <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : "var(--black)" }}>{companyData?.address}</Typography>
                    <Typography variant="body2" className="text-primary"> <a href={companyData?.websiteUrl} target="_blank" rel="noopener noreferrer">{companyData?.websiteUrl}</a></Typography>
                    <Typography variant="body2" className="text-primary">{companyData?.email}</Typography>
                    <Grid sx={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 2 }}>
                        <IconButton component="a" href={companyData?.facebookUrl} target="_blank" rel="noopener noreferrer"><Facebook sx={{ color: "#1877F2" }} /></IconButton>
                        <IconButton component="a" href={companyData?.xUrl} target="_blank" rel="noopener noreferrer"> <XIcon sx={{ color:darkMode ? '#fff':'#000' }} /> </IconButton>
                        <IconButton component="a" href={companyData?.youTubeUrl} target="_blank" rel="noopener noreferrer"> <YouTube sx={{ color: "#FF0000" }} /> </IconButton>
                        <IconButton component="a" href={companyData?.linkedInUrl} target="_blank" rel="noopener noreferrer"> <LinkedIn sx={{ color: "#0077B5" }} /> </IconButton>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Grid container justifyContent="flex-end">
                    <Button onClick={onClose} variant="contained" color="secondary" sx={{ border: '1px solid green', marginTop: "10px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>Close</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default CompanyInfoPage;
